<template>
    <section>
        <ValidationObserver class="columns" ref="observer">
            <div class="column">
                <ValidationProvider :rules="{ start_date_before_end_date: maxYear, required: true }"
                    v-slot="{ errors, failedRules }">
                    <b-field label="Año desde: *" 
                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                        <multiselect v-model="minYear" :options="year_options" :searchable="true" :close-on-select="true" :allow-empty="true"
                            selectLabel="Presione para seleccionar" selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                            placeholder="Elija un año" />
                    </b-field>
                </ValidationProvider>
            </div>

            <div class="column">
                <ValidationProvider :rules="{ end_date_not_before_start_date: minYear, required: true }"
                    v-slot="{ errors, failedRules }">
                    <b-field label="Año hasta: *" 
                        :type="{ 'is-danger': Object.keys(failedRules).length > 0 }"
                        :message="Object.keys(failedRules).length > 0 ? errors[0] : ''">
                        <multiselect v-model="maxYear" :options="year_options" :searchable="true" :close-on-select="true" :allow-empty="true"
                            selectLabel="Presione para seleccionar" selectedLabel="Seleccionado" deselectLabel="Presione para deseleccionar"
                            placeholder="Elija un año" />
                    </b-field>
                </ValidationProvider>
            </div>

            <div class="column is-narrow">
                <br>
                <b-field label=" ">
                    <b-button icon-left="search" type="is-info" label="Aplicar Filtro" @click="check()" />
                </b-field>
            </div>
        </ValidationObserver>

        <div class="columns">
            <div class="column">
            <b-message type="is-info" has-icon>
                La actividad académica solo puede ser <b>editada</b> o <b>anulada</b> por quien agregó estos datos
                al sistema. Si hay un error en la información por favor ponerse en contacto con la persona propietaria.
                Si el dato que ve no corresponde a usted, puede <b>eliminar</b> su participación en la sección
                <b>Participantes</b>, y este dato dejará de estar visible.
            </b-message>
            </div>
        </div>
        <b-tabs position="is-centered" @input="changeTab" :multiline="true">
            <b-tab-item v-for="item in items" v-bind:key="item.content" :value="item.content" :label="item.tab"
                :icon="item.icon" :disabled="item.disabled"/>
        </b-tabs>
        <!-- COMPONENTE AQUI -->
        <keep-alive>
            <component v-bind:is="currentTabComponent" :person-id="personId" :photo-url="photoUrl" :min-year="minYear" :max-year="maxYear" :change-filter="changeFilter"
                :cargo-principal="cargoPrincipal" :hide-update="true" :can-create-document="canCreateDocument" :can_create_academic_activity="can_create_academic_activity" />
        </keep-alive>

        <!-- FIN COMPONENTE -->
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import MyResearchData from './my_research_data_tab.vue'
import MyPublications from './my_publications_tab.vue'
import MyProjects from './my_projects_tab.vue'
import MyPatents from './my_patents_tab.vue'
import MyDisclosures from './my_disclosures_tab.vue'
import AddAcademicActivityDropdown from "./add_academic_activity_dropdown.vue"
import { ValidationProvider } from 'vee-validate'
export default {
    components: {
        MyResearchData, MyPublications, MyProjects, MyPatents, MyDisclosures, AddAcademicActivityDropdown
    },
    props:[
        'personId','photoUrl', 'cargoPrincipal', 'canCreateDocument', 'can_create_academic_activity'
    ],
    data() {
        return {
            isLoading:false,
            currentTab: 'MyResearchData',
            items: [
                {tab: 'Mis Datos de Investigación',content: 'MyResearchData', icon:"book-reader", disabled: false},
                {tab: 'Publicaciones',content: 'MyPublications', icon:"file-alt", disabled: false},
                {tab: 'Proyectos',content: 'MyProjects', icon:"folder-open", disabled: false},
                {tab: 'Patentes',content: 'MyPatents', icon:"lightbulb", disabled: false},
                {tab: 'Disclosures',content: 'MyDisclosures', icon:"folder", disabled: true},
            ],
            minYear:new Date().getFullYear() - 5,
            maxYear:new Date().getFullYear(),
            year_options:Array.from({length:(new Date().getFullYear()-2000+1)},(v,k)=>k+2000).reverse(),
            changeFilter: false,
        }
    },
    methods: {
        changeTab: function(value){
            this.currentTab = value
        },
        async check() {
            let valid = await this.$refs.observer.validate()
            if (!valid) {
                this.$buefy.dialog.alert({
                    title: 'Error',
                    message: 'Los campos del Filtro de Años tienen errores.', 
                    type: 'is-danger',
                    hasIcon: true, 
                    icon: 'times-circle', 
                    iconPack: 'fa', 
                    ariaRole: 'alertdialog', 
                    ariaModal: true
                })
            } else {
                this.changeFilter = !this.changeFilter
            }
        }
    },
    computed: {
        currentTabComponent: function () {
            return this.currentTab
        }
    }
}
</script>